"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spreadHubCapacityBetweenFcs = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const _ = require("lodash");
function apportionUnits(units, warehouseIds, maximums) {
    const defaultDailyMaxUnits = 300;
    const total = _.sumBy(warehouseIds, (id) => maximums[id] || defaultDailyMaxUnits);
    return warehouseIds.map((id) => [id, Math.round(((maximums[id] || defaultDailyMaxUnits) * units) / total)]);
}
function spreadHubCapacityBetweenFcs(items, warehouseToHub, maximums) {
    const ctx = { fn: "spreadHubCapacityBetweenFcs" };
    commons_logs_1.log.info(Object.assign(Object.assign({}, ctx), { warehouseToHub, maximums }), "start");
    const hubToWarehouseIds = _(Object.entries(warehouseToHub))
        .filter(([_warehouseId, hub]) => !!hub)
        .groupBy(([_warehouseId, hub]) => hub)
        .mapValues((pairs) => _.compact(pairs.map(([warehouseId, _hub]) => warehouseId)))
        .value();
    commons_logs_1.log.info(Object.assign(Object.assign({}, ctx), { hubToWarehouseIds }), "got warehouse-ids for each hub");
    const result = {};
    for (const { warehouseId, hubId, qty } of items) {
        if (warehouseId) {
            result[warehouseId] = (result[warehouseId] || 0) + qty;
        }
        else if (hubId) {
            const warehouseIds = hubToWarehouseIds[hubId] || [];
            for (const [wh, whUnits] of apportionUnits(qty, warehouseIds, maximums)) {
                result[wh] = (result[wh] || 0) + Math.round(whUnits);
            }
        }
        else {
            commons_logs_1.log.error(ctx, "no hubId or warehouseId?!");
        }
    }
    commons_logs_1.log.info(Object.assign(Object.assign({}, ctx), { result }), "done");
    return result;
}
exports.spreadHubCapacityBetweenFcs = spreadHubCapacityBetweenFcs;
//# sourceMappingURL=WarehouseCapacityUtils.js.map